import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { sanitizeHtml } from '/react4xp/shared/sanitizeHtml';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	SERVICES_FIELD_NAME,
	SERVICES_WHERE,
} from '../constants';


export const WhereOtherTextField = ({
	phrases,
	whereLabel,
}: {
	phrases: Phrases;
	whereLabel: string;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const where: string = useWatch({ control, name: SERVICES_FIELD_NAME.WHERE}) as string;
	const isOther = where === SERVICES_WHERE.OTHER;
	const localizedOther = sanitizeHtml(phrases['notificationForm.services.whereField.value.other']);
	const label = isOther
		? localizedOther
		: '';
	return (
		<TextField
			errorSummaryLabel={`${whereLabel} - ${label}`}
			fullWidth
			label={<Span textSize='lg'>{label}</Span>}
			name={SERVICES_FIELD_NAME.WHERE_OTHER}
			showIf={() => isOther}
		/>
	);
};

